import PropTypes from 'prop-types';
import React from 'react';
import InventoryListingImage from '../InventoryListingImage/index.js';

/**
 *  Molecule to encapsulate `SideBar` content passed from InventoryListing to ItemCard
 */
function InventoryListingSideBar(_ref) {
  let {
    className,
    lazyLoad,
    listing,
    uiContext,
    orientation,
    ...rest
  } = _ref;
  let listingType;
  if (uiContext === 'snapshot') {
    listingType = 'card';
  } else {
    listingType = 'listing';
  }
  return /*#__PURE__*/React.createElement(InventoryListingImage, Object.assign({
    className: className,
    data: listing,
    lazyLoad: lazyLoad,
    orientation: orientation,
    uiContext: listingType,
    withPreviewImages: uiContext === 'simplified'
  }, rest));
}
export default InventoryListingSideBar;